/**
 * @file Re-exports the platform footer component.
 */
import PlatformFooter from "./PlatformFooter";

export default PlatformFooter;
